/**
 * How an order card names an order, and whether it is cash-on-delivery. Uplifted 2026-09-15 for
 * the shared `MyOrderCard`. A leaf like `fulfillmentStatus.ts`: constants only, loadable in node.
 *
 * `getParentOrderId` / `getOrderId` were TOKEN-IDENTICAL in both apps' `helper/myOrderHelpers`.
 * `isOrderCod` had the same body in two HOMES — web `helper/myOrderHelpers`, mobile
 * `helper/saleHelpers` (the `validateManualDiscountLimitFn` shape, D6). One definition here;
 * each app re-exports it from the file its importers already use.
 */
import { COD, ONLINE } from "../../utils/constants/shared";
import { isPosChannel } from "../../models/sale/shared"; // DP-7554 (release_4.0.0 5f3831709): Kiosk counts as POS — plan §12 V5
import { DOTPE_SOURCE_TYPES } from "../../data/constants/shared";

export function getParentOrderId(invoiceNumber: any) {
  return invoiceNumber?.split("##")[0]?.slice(-4);
}

export function getOrderId(orderData: any = {}, showType = "") {
  if (isPosChannel(orderData?.channel)) {
    return orderData.billNumber?.slice(-4) || orderData.offlineNumber;
  }
  if (orderData?.channel?.toLowerCase() === ONLINE) {
    let sourceInfo = orderData?.sourceInfo;
    if (DOTPE_SOURCE_TYPES.includes(sourceInfo?.sourceType)) {
      // get parent order id if it is from dotpe
      return getParentOrderId(orderData?.sourceInfo?.invoiceNumber);
    }
    if (showType === "cart") {
      return orderData?.sourceInfo?.invoiceNumber
        ? orderData?.sourceInfo?.invoiceNumber?.slice(-4) || orderData.offlineNumber
        : orderData.billNumber?.slice(-4);
    }
    if (showType === "card") {
      return orderData?.label ? orderData?.label || orderData.offlineNumber : orderData.billNumber?.slice(-4);
    }
  }
  return "";
}

export const isOrderCod = (orderData: any) => {
  if (
    orderData?.tags?.length &&
    orderData?.tags?.includes(COD) &&
    orderData?.paymentInfo?.balanceAmount === orderData?.billTotal
  ) {
    return true;
  }
  return false;
};
